import React, { MouseEventHandler, ReactNode } from 'react';
import styled, { css } from 'styled-components/macro';
import cx from 'classnames';

import { Tooltip } from './Tooltip';
import { NavLink } from 'react-router-dom';

type Props = {
  icon?: ReactNode;
  text: ReactNode;
  onClick?: MouseEventHandler;
  className?: string;
  tooltip?: ReactNode;
  url?: string;
  active?: boolean;
  id?: string;
};

export const Badge = (props: Props) => {
  const { active, className, icon, id, onClick, text, tooltip, url } = props;

  const content = url ? (
    <NavLink to={url} onClick={onClick} className="link">
      {text}
    </NavLink>
  ) : (
    text
  );

  const badge = (
    <BadgeWrapper id={id} className={cx('badge', className, { link: onClick })} onClick={url ? undefined : onClick}>
      <span className={cx('inner', { active })}>
        {icon && <BadgeIcon>{icon}</BadgeIcon>}
        <span className="text">{content}</span>
      </span>
    </BadgeWrapper>
  );

  if (tooltip) {
    return (
      <Tooltip value={tooltip} className={className}>
        {badge}
      </Tooltip>
    );
  }

  return badge;
};

const BadgeWrapper = styled.div<{ url?: string }>`
  font-size: 0.92rem;
  user-select: ${(props) => (props.onClick ? 'pointer' : 'none')};

  a,
  a:active,
  a:not(.btn),
  a:visited {
    text-decoration: none;
    cursor: pointer;
  }

  .link,
  &.link {
    cursor: pointer;
  }

  .text {
    font-size: 0.9rem;
    vertical-align: baseline;
  }

  ${(props) =>
    (props.onClick || props.url) &&
    css`
      .inner {
        color: ${props.theme.primaryBtn1HoverBg};
        transition: 0.3s color;

        &.active,
        :hover {
          color: unset;
        }

        &.active {
          font-weight: bold;
          color: ${props.theme.primaryBtn1Bg};
        }
      }
    `}
`;

const BadgeIcon = styled.span`
  margin-right: 5px;
`;
